import { inject, Injectable } from '@angular/core';
import { AuthFacade, handleIncorrectPortal, TokenService } from '@rx-applications/shared/auth/data-access';

@Injectable({
  providedIn: 'root',
})
export class AuthApiFacade {
  #authFacade: AuthFacade = inject(AuthFacade);
  #tokenService: TokenService = inject(TokenService);

  error$ = this.#authFacade.error$;
  hasLoadTokenFromLocaleStorageCompleted$ = this.#authFacade.hasLoadTokenFromLocaleStorageCompleted$;
  isAuthenticated$ = this.#authFacade.isAuthenticated$;
  token$ = this.#authFacade.token$;

  logoutAuthGuard(redirectUrl: string = ''): void {
    this.#authFacade.logoutAuthGuard(redirectUrl);
  }

  logout(): void {
    this.#authFacade.logout();
  }

  requestPassword(email: string): void {
    this.#authFacade.requestPassword(email);
  }

  hideSuccessMessage(): void {
    this.#authFacade.hideSuccessMessage();
  }

  hideErrorMessage(): void {
    this.#authFacade.hideErrorMessage();
  }

  getTokenWebsiteId(): number | null {
    return this.#tokenService.getWebsiteId();
  }

  getTokenEmail(): string | null {
    return this.#tokenService.getEmail();
  }

  getTokenRole(): string | string[] | null {
    return this.#tokenService.getRole();
  }

  isAdmin(): boolean {
    const role = this.getTokenRole();
    const adminRole = 'ADMIN';
    return Array.isArray(role) 
      ? role.some((r) => r.toLocaleUpperCase() === adminRole) 
      : role?.toLocaleUpperCase() === adminRole;
  }

  handleIncorrectPortal(props: { email: string }) {
    return handleIncorrectPortal(props);
  }
}
